export function parseUrl(url: string) {
  const regex = /\{([^{}]+)\}/g;

  if (!regex.exec(url)) return new URL(url).pathname;

  return new URL(url.replace(/\{([^{}]+)\}/g, ':$1')).pathname;
}
